import UiAvatar from './UiAvatar'
import UiButton from './UiButton'
import UiImage from './UiImage'
import UiLoader from './UiLoader'
import UiSvgIcon from './UiSvgIcon'
import UiPerson from './UiPerson'
import UiProgressBar from './UiProgressBar'
import UiCheckbox from './UiCheckbox'
import UiCheckboxSelect from './UiCheckboxSelect/UiCheckboxSelect'
import UiCheckboxSelectOption from './UiCheckboxSelect/UiCheckboxSelectOption'
import UiDropdownSelect from './UiDropdownSelect/UiDropdownSelect'
import UiTag from './UiTag'
import UiCounter from './UiCounter'
import UiBadgeSelect from './UiBadgeSelect/UiBadgeSelect'
import UiUserItem from './UiCatalog/UiUserItem'
import UiChildItem from './UiCatalog/UiChildItem'
import UiCollapseButton from './UiCollapseButton'
import UiSubscriptionBadge from './UiSubscriptionBadge'
import UiLogo from './UiLogo'
import UiInput from './UiInput'
import UiTextarea from './UiTextarea'
import UiFile from './UiFile'
import UiPrice from './UiPrice'
import UiObserver from './UiObserver'

export default function initializeUiKit (app) {
  app.component('UiAvatar', UiAvatar)
  app.component('UiButton', UiButton)
  app.component('UiImage', UiImage)
  app.component('UiLoader', UiLoader)
  app.component('UiSvgIcon', UiSvgIcon)
  app.component('UiPerson', UiPerson)
  app.component('UiProgressBar', UiProgressBar)
  app.component('UiCheckbox', UiCheckbox)
  app.component('UiCheckboxSelect', UiCheckboxSelect)
  app.component('UiCheckboxSelectOption', UiCheckboxSelectOption)
  app.component('UiDropdownSelect', UiDropdownSelect)
  app.component('UiTag', UiTag)
  app.component('UiCounter', UiCounter)
  app.component('UiBadgeSelect', UiBadgeSelect)
  app.component('UiUserItem', UiUserItem)
  app.component('UiChildItem', UiChildItem)
  app.component('UiCollapseButton', UiCollapseButton)
  app.component('UiSubscriptionBadge', UiSubscriptionBadge)
  app.component('UiLogo', UiLogo)
  app.component('UiInput', UiInput)
  app.component('UiTextarea', UiTextarea)
  app.component('UiFile', UiFile)
  app.component('UiPrice', UiPrice)
  app.component('UiObserver', UiObserver)
}
